export function selectSendFeedback(state) {
  return state.sendFeedback;
}
export function selectSendFeedbackSucceed(state) {
  return state.sendFeedback.status === 'succeed';
}